import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";
import { ArrowLeft, Scale, Mail, Globe } from "lucide-react";
import { VIEWER_TERMS, VIEWER_TERMS_EFFECTIVE } from "@/content/viewerTerms";

const EMAIL = "hello@cinevoya.com";

const Block = ({ item }) =>
  Array.isArray(item) ? (
    <ul className="list-disc pl-5 space-y-1.5 marker:text-terracotta">
      {item.map((li) => <li key={li}>{li}</li>)}
    </ul>
  ) : (
    <p>{item}</p>
  );

const ContactCard = () => (
  <div className="mt-3 p-5 rounded-xl border border-terracotta/30 bg-terracotta/5 space-y-1.5" data-testid="terms-contact-card">
    <p className="font-display font-bold text-foreground">CINEVOYA</p>
    <p className="flex items-center gap-2"><Globe className="w-4 h-4 text-terracotta" /> <a href="https://www.cinevoya.com" className="hover:text-terracotta">https://www.cinevoya.com</a></p>
    <p className="flex items-center gap-2"><Mail className="w-4 h-4 text-terracotta" /> <a href={`mailto:${EMAIL}?subject=Viewer%20Support%20%2F%20Terms%20and%20Conditions`} className="hover:text-terracotta" data-testid="terms-contact-email">{EMAIL}</a></p>
    <p className="text-xs text-foreground/55">Subject: Viewer Support / Terms and Conditions</p>
    <p className="pt-2">Cinevoya is committed to providing an accessible, secure and enjoyable platform for discovering and experiencing African stories.</p>
  </div>
);

export default function ViewerTerms() {
  return (
    <div className="min-h-screen bg-ink grain">
      <Navbar />
      <div className="pt-28 px-6 sm:px-12 lg:px-20 max-w-3xl mx-auto pb-16" data-testid="viewer-terms-page">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-terracotta hover:text-ember mb-6" data-testid="terms-back-link">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to home
        </Link>
        <div className="flex items-center gap-3 mb-2">
          <Scale className="w-6 h-6 text-gold" />
          <p className="text-xs uppercase tracking-widest text-terracotta font-semibold">Legal · Viewers</p>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-black mb-3">Viewer Terms and Conditions</h1>
        <p className="text-foreground/55 text-sm">
          Effective {VIEWER_TERMS_EFFECTIVE} · Website: <a href="https://www.cinevoya.com" className="hover:text-terracotta">www.cinevoya.com</a> · Contact: <a href={`mailto:${EMAIL}`} className="hover:text-terracotta">{EMAIL}</a>
        </p>

        <nav className="mt-8 p-4 rounded-xl border border-white/10 bg-surface/60 grid sm:grid-cols-2 gap-x-6 gap-y-1 text-sm" data-testid="terms-toc">
          {VIEWER_TERMS.map((s, i) => (
            <a key={s.title} href={`#terms-${i + 1}`} className="text-foreground/65 hover:text-terracotta transition-colors">{s.title}</a>
          ))}
        </nav>

        {VIEWER_TERMS.map((s, i) => (
          <section key={s.title} id={`terms-${i + 1}`} className="mt-10 scroll-mt-28" data-testid={`terms-section-${i + 1}`}>
            <h2 className="font-display text-base md:text-lg font-bold mb-3 uppercase tracking-wide">{s.title}</h2>
            <div className="text-sm text-foreground/75 leading-relaxed space-y-3">
              {s.body.map((item, j) => <Block key={j} item={item} />)}
              {s.contact && <ContactCard />}
            </div>
          </section>
        ))}

        <div className="mt-14 text-center">
          <p className="font-display font-black tracking-wide text-terracotta">CINEVOYA – AFRICA'S STORIES. WORLDWIDE.</p>
          <p className="text-xs text-foreground/50 tracking-[0.3em] mt-1">DISCOVER. WATCH. SUPPORT.</p>
        </div>
      </div>
      <SiteFooter tagline="Curated African short cinema." maxWidth="max-w-3xl" />
    </div>
  );
}
